/**
* Created by itaic on 12/3/15.
*/
define(function (require) {

    window.lpTag = window.lpTag || {};

    var AgentSurveyViewController = require('web-agent-viewControllers/AgentSurveyViewController');
    var AgentOutcomesViewController = require('web-agent-viewControllers/AgentOutcomesViewController');

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');

    var AgentActionsWidgetContainer = WidgetViewController.extend({
        ControllerName: 'AgentActionsWidgetContainer',
        applicationType: 'AgentActionsWidgetContainer',

        LPViewMap: {
            surveyContainer: ".lpview_agent_survey_container",
            surveyToggle: ".lpview_agent_survey_toggle",
            surveyContent: ".lpview_agent_survey_content",
            surveyToggleIcon: ".lpview_agent_survey_icon",
            outcomesContainer: ".lpview_conversation_outcomes_container",
            outcomesContent: ".lpview_conversation_outcomes_content",
            outcomesToggle: ".lpview_conversation_outcomes_toggle",
            outcomesToggleIcon: ".lpview_conversation_outcomes_icon"
        },
        viewClass: {
            open: "opened"
        },
        staticProps: {
            agentSurvey: "agentSurvey",
            outComes: "outComes"
        },

        initialize: function (constructorData) {
            this.surveyVisible = true;
            this.outComesVisible = true;
            this.logger = WebAgentLogger.getLogger(this.applicationType);
            this.logger.debug('initializing', 'initialize', constructorData);
            this.logicController = lpTag.WebAgent.logicController;
            this.children = {};
            this.visitorId = constructorData.visitorId;
            this.constructorData = constructorData;
        },

        events: function () {
            this.logger.debug('binding events', 'events');
            var participantPath  = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            var sessionIdPath = participantPath + '.participantInfo.sessionId';
            this.sessionId = this.getModelParam(sessionIdPath);
            this.bindModel({modelPath : participantPath + ".chats", callback : this.setChatId});
            this.bindViewEvent({ selector: this.LPViewMap.outcomesToggle, DOMEvent: "click", callback: this.toggleOutcomes });
            this.bindViewEvent({ selector: this.LPViewMap.surveyToggle, DOMEvent: "click", callback: this.toggleSurvey });
            this.bindModel({modelPath : participantPath + '.participantTag', callback: this.handleParticipantTag});
            this.onDispose( { callback : this.whenDying, context: this });
        },

        render: function () {
            this.addViews();
            this.logger.debug('rendering', 'render');
        }
    });

    AgentActionsWidgetContainer.prototype.setChatId = function (data) {
        if (data && data.newValue) {
            var chatIds = Object.keys(data.newValue);
            for (var chat in chatIds) {
                unbindChat.call(this);
                this.chatId = chatIds[chat];
                bindChat.call(this);
            }
        }
        function unbindChat() {
            if (this.chatId) {
                this.unbindModel({modelPath : 'chats.' + this.chatId + '.agentSurvey.active', callback: this.handleSurveyState });
            }
        }
        function bindChat() {
            if (this.chatId) {
                this.bindModel({modelPath: 'chats.' + this.chatId + '.agentSurvey.active', callback: this.handleSurveyState});
            }
        }
    };
    AgentActionsWidgetContainer.prototype.handleParticipantTag = function (data) {
        if (!data.newValue) {
            return;
        }
        if (this.colorTag) {
            this.removeClass(this.LPViewMap.outcomesContainer, this.colorTag);
        }
        this.colorTag = data.newValue;
        this.addClass(this.LPViewMap.outcomesContainer, this.colorTag);
    };

    AgentActionsWidgetContainer.prototype.handleSurveyState = function (data) {
        if (data && data.newValue === true) {
            this.show(this.LPViewMap.surveyContainer);
        } else if (data && data.newValue === false) {
            this.children[this.staticProps.agentSurvey].dispose();
        }
    };

    AgentActionsWidgetContainer.prototype.addViews = function () {
        this.children[this.staticProps.agentSurvey] = new AgentSurveyViewController({
            lazyLoaderAppName: AgentSurveyViewController.applicationType,
            visitorId: this.visitorId,
            chatId: this.chatId,
            myChatsOnly: true,
            modelController: this.constructorData.modelController,
            templateFile: "LP_agent_survey.html"
        });
        this.addView({viewToAdd: this.children[this.staticProps.agentSurvey].view, targetView: this.getFirstElement(this.LPViewMap.surveyContent)});
        this.hide(this.LPViewMap.surveyContainer);
        this.children[this.staticProps.outComes] = new AgentOutcomesViewController({
            lazyLoaderAppName: AgentOutcomesViewController.applicationType,
            visitorId: this.visitorId,
            sessionId: this.sessionId,
            myChatsOnly: true,
            conversationOutComes: this.constructorData.conversationOutComes,
            modelController: this.constructorData.modelController
        });
        this.addView({viewToAdd: this.children[this.staticProps.outComes].view, targetView: this.getFirstElement(this.LPViewMap.outcomesContent)});
    };

    AgentActionsWidgetContainer.prototype.toggleSurvey = function () {
        if (this.surveyVisible) {
            this.hideSurvey();
        } else {
            this.showSurvey();
        }
    };

    AgentActionsWidgetContainer.prototype.toggleOutcomes = function () {
        if (this.outComesVisible) {
            this.hideOutcomes();
        } else {
            this.showOutcomes();
        }
    };

    AgentActionsWidgetContainer.prototype.hideSurvey = function (destroy) {
        var surveyContainer = this.getFirstElement(this.LPViewMap.surveyContent);
        if (destroy) {
            surveyContainer.parentNode.removeChild(surveyContainer);
        } else {
            this.lpHide(surveyContainer);
            this.removeClass(this.LPViewMap.surveyToggleIcon, this.viewClass.open);
            this.surveyVisible = false;
        }
    };

    AgentActionsWidgetContainer.prototype.showSurvey = function () {
        this.lpShow(this.LPViewMap.surveyContent);
        this.addClass(this.LPViewMap.surveyToggleIcon, this.viewClass.open);
        this.surveyVisible = true;
    };

    AgentActionsWidgetContainer.prototype.hideOutcomes = function (destroy) {
        var outcomesContainer = this.getFirstElement(this.LPViewMap.outcomesContent);
        if (destroy) {
            outcomesContainer.parentNode.removeChild(outcomesContainer);
        } else {
            this.lpHide(outcomesContainer);
            this.removeClass(this.LPViewMap.outcomesToggleIcon, this.viewClass.open);
            this.outComesVisible = false;
        }
    };

    AgentActionsWidgetContainer.prototype.showOutcomes = function () {
        this.lpShow(this.LPViewMap.outcomesContent);
        this.addClass(this.LPViewMap.outcomesToggleIcon, this.viewClass.open);
        this.outComesVisible = true;
    };

    AgentActionsWidgetContainer.prototype.whenDying = function () {
        for (var key in this.children) {
            if (typeof this.children[key].dispose === 'function') {
                try {
                    this.children[key].dispose();
                } catch (exc) {
                    this.logger.error("Hey we fubarred something in killing the children, look at the kids, will ya?", "dispose");
                }
            }
        }
    };

    return AgentActionsWidgetContainer;

});
